import { getConfig } from '../config/constants';

export const useEnv = () => getConfig(useRuntimeConfig());
